import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-update-profile',
  templateUrl: './update-profile.component.html',
  styleUrls: ['./update-profile.component.scss'],
})
export class UpdateProfileComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
